<template>
  <div>
    <b-card-actions
      title="Filters"
      action-collapse
      collapsed
    >
      <b-row>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Delivered Date"
            label-for="delivered_date"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['status_date']"
                :opens="'right'"
                @update="updateDateRange('status_date', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <filter-buttons
            :filter-data="filters"
            :apply-filters="applyFilters"
            :clear-filters="clearFilters"
          />
        </b-col>
      </b-row>
    </b-card-actions>
    <b-card
      no-body
    >
      <b-overlay
        :show="submitLoading"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <div
          class="m-2"
        >
          <b-row
            cols="12"
            class="pt-1 pb-1"
          >
            <b-col
              class="justify-content-end"
            >
              <b-row
                class="d-flex align-items-center justify-content-end mr-1"
              >
                <b-col class="d-flex justify-content-start">
                  <div class="font-weight-bolder text-muted mobile-margin">
                    {{ `${waybillSelected.length} record${waybillSelected.length === 1 ? '':'s'}` }} selected
                  </div>
                </b-col>
                <b-col md="4">
                  <v-select
                    v-model="selectedRider"
                    :options="Rider"
                    :reduce="option => option.id"
                    label="first_name"
                    placeholder="Select Rider"
                    class="ml-1 mobile-margin"
                    @input="deselectAll()"
                  >
                    <template v-slot:option="option">
                      {{ option.reference_id }} | {{ option.first_name }} {{ option.last_name }}
                    </template>
                  </v-select>
                </b-col>
                <div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    class="custom-button-color-blur mobile-margin mr-2"
                    @click="loadBills"
                  >
                    Get Waybills
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    class="custom-button-color mobile-margin"
                    :disabled="waybillSelected.length > 0 ? false : true"
                    @click="SubmitDeposit"
                  >
                    Submit
                  </b-button>
                </div>
                <div class="ml-1">
                  <ReportTableButtons
                    :items="items"
                    :json_fieldz="json_fields"
                    :name="`${downloadReportName} - Page ${page}.xls`"
                    :bulkname="`${downloadReportName}.xls`"
                    :fetch="fetchDataForRiderNoPagination"
                    @refresh="fetchDataForRider"
                  />
                </div>
              </b-row>
            </b-col>
          </b-row>
          <div>
            <b-row>
              <b-col md="12">
                <b-overlay
                  id="overlay-background"
                  blur="10px"
                  opacity="0.30"
                  rounded="sm"
                  variant="light"
                >
                  <b-table
                    :per-page="perPage"
                    :items="items"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    hover
                    responsive
                    striped
                    show-empty
                    class="table-responsive"
                  >
                    <template #empty>
                      <TableDataFetching
                        :rows="items"
                        :data-loading="dataLoading"
                      />
                    </template>
                    <template #head(id)>
                      <div class="d-flex align-items-start">
                        <div>
                          <b-form-checkbox
                            id="selectAllCheckbox"
                            v-model="selectAllCheckbox"
                            name="selectAllCheckbox"
                            @change="onClickSelectAllCheckbox()"
                          />
                        </div>
                      </div>
                    </template>
                    <template #cell(id)="data">
                      <div class="d-flex align-items-start">
                        <div>
                          <div class="font-weight-bolder">
                            <b-form-checkbox
                              v-model="waybillSelected"
                              :value="data.item.waybill_number"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #cell(logo_url)="data">
                      <div class="d-flex align-items-center">
                        <div>
                          <div class="font-weight-bolder">
                            {{ data.item.waybill_number }}
                          </div>
                          <div class="font-small-2">
                            {{ data.item.order_no }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #cell(customer_name)="data">
                      <div class="d-flex align-items-center">
                        <div>
                          <div class="font-weight-bolder">
                            {{ getCustomerFieldValue(data.item, 'customer_name') }}
                          </div>
                          <div class="font-small-2">
                            {{ getCustomerFieldValue(data.item, 'customer_email') }}
                          </div>
                          <div class="font-small-2">
                            <div><b>Primary number: </b>{{ getCustomerFieldValue(data.item, 'customer_phone') }}</div>
                          </div>
                          <div
                            v-if="shouldShowSecondaryPhone(data.item)"
                            class="font-small-2"
                          >
                            <div><b>Second number: </b>{{ getCustomerFieldValue(data.item, 'customer_secondary_phone') || '-' }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #cell(cod)="data">
                      <span>{{ __numberWithCommas(data.value, true) }}</span>
                    </template>
                    <template #cell(collected_cod)="data">
                      <span>{{ __numberWithCommas(data.value, true) }}</span>
                    </template>
                    <template #cell(rider_commission)="data">
                      <span>{{ __numberWithCommas(data.value, true) }}</span>
                    </template>
                    <template #cell(status.key)="data">
                      <order-status-badge :status-key="data.value" />
                    </template>
                  </b-table>
                </b-overlay>
                <div class="mx-2 mb-2">
                  <b-row
                    cols="12"
                  >
                    <b-col
                      class="d-flex align-items-center justify-content-sm-start"
                      md="3"
                    >
                      <label class="width-75">Per page</label>
                      <v-select
                        v-model="perPage"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="pageOptions"
                        :clearable="false"
                        class="per-page-selector d-inline-block width-100"
                      />
                    </b-col>
                    <!-- Pagination -->
                    <b-col
                      class="d-flex align-items-center justify-content-sm-end"
                      md="9"
                    >
                      <span class="text-muted pagination-text mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                      <b-pagination
                        v-model="page"
                        :total-rows="(meta.total)? meta.total : 0"
                        :per-page="perPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                      >
                        <template #prev-text>
                          <feather-icon
                            icon="ChevronLeftIcon"
                            size="18"
                          />
                        </template>
                        <template #next-text>
                          <feather-icon
                            icon="ChevronRightIcon"
                            size="18"
                          />
                        </template>
                      </b-pagination>

                    </b-col>

                  </b-row>
                </div>
              </b-col>
            </b-row>
          </div>
          <!-- <div>
          <b-overlay
            id="overlay-background"
            :show="Expenceloading"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <div>
              <b-form-group
                label="Expenses"
                class="ml-2"
              >
                <b-row
                  v-for="(expense, expense_index) in expenses_section"
                  :key="expense_index"
                >
                  <b-col md="1">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      class="mt-1 mt-md-2 mb-1 mb-md-0 btn-icon"
                      @click="addSectionExpences"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class=""
                      />
                    </b-button>
                  </b-col>
                  <b-col
                    cols="7"
                    sm="6"
                    md="4"
                  >
                    <b-form-group
                      label="Type"
                      label-for="v-ret-ao"
                    >
                      <v-select
                        v-model="expense.type"
                        :options="ExpenceOptions"
                        :reduce="option => option.type"
                        label="name"
                        placeholder="Select Expenses"
                        class="w-250"
                      >
                        <template v-slot:option="option">
                          {{ option.name }}
                        </template>
                      </v-select>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="7"
                    sm="4"
                    md="2"
                  >
                    <b-form-group
                      label="Amount"
                      label-for="v-ret-ao"
                    >
                      <b-form-input
                        id="v-ret-ao"
                        v-model="expense.amount"
                        size="md"
                        type="number"
                        autocomplete="nope"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="1">
                    <div v-if="expense_index !== 0">
                      <b-button
                        v-ripple.400="'rgba(238, 114, 115)'"
                        variant="danger"
                        class="mt-2 btn-icon"
                        @click="removeSectionExpences"
                      >
                        <feather-icon
                          icon="Trash2Icon"
                          class=""
                        />
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <span
                      style="visibility: hidden"
                    >Spacing for 1 row</span>
                  </b-col>
                  <b-col md="3" />
                </b-row>
                <b-row>
                  <b-col md="3">
                    <span
                      style="visibility: hidden"
                    >Spacing for 1 row</span>
                  </b-col>
                  <b-col md="3" />
                </b-row>
                <b-row>
                  <b-col cols="1" />
                </b-row>
              </b-form-group>
            </div>
          </b-overlay>
        </div> -->
          <!-- <div>
          <b-form-group>
            <b-row>
              <b-col md="10" />
              <b-col
                md="2"
                class="d-flex align-items-center justify-content-end"
              >
                submit button was here
              </b-col>
              <b-row>
                <b-col cols="1" />
              </b-row>
            </b-row>
          </b-form-group>
        </div> -->
        </div></b-overlay>
    </b-card>
    <deposit-detail-modal ref="deposit_detail_modal" />
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BFormGroup,
  // BFormInput,
  BRow,
  VBModal,
  BButton,
  VBTooltip,
  BPagination,
  BFormCheckbox,
  BTable,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import vSelect from 'vue-select'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { heightTransition } from '@core/mixins/ui/transition'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import DepositDetailModal from '@/components/FinanceModuleForms/InfoModals/DepositDetailModal.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FilterButtons from '@/components/Filter/FilterButtons.vue'

const FinanceRepository = RepositoryFactory.get('finance')
const RiderRepository = RepositoryFactory.get('rider')

export default {
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BCol,
    BFormGroup,
    // BFormInput,
    BFormCheckbox,
    BRow,
    vSelect,
    BCard,
    BButton,
    BPagination,
    BTable,
    BOverlay,
    BCardActions,
    OrderStatusBadge,
    AdvancedDateFilter,
    DepositDetailModal,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, heightTransition],
  data() {
    return {
      filters: {
        status_date: {
          startDate: null,
          endDate: null,
        },
      },
      selectedRider: '',
      Rider: [],
      waybillSelected: [],
      ExpenceOptions: [],
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['Y', 'm', 'd'],
        },
      },
      dataLoading: false,
      Expenceloading: false,
      submitLoading: false,
      sort: '',
      perPage: 10,
      pageOptions: [10, 20, 50],
      expenseType: [
        { name: 'Fuel', value: 'fuel' },
        { name: 'Food', value: 'food' },
      ],
      totalRows: 1,
      page: 1,
      meta: {},
      dir: false,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      disabled: true,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [],
      items: [],
      expenses_section: [
        {
          id: 1,
          type: '',
          amount: '',
        },
      ],
      json_fields: {
        'Waybill Number': 'waybill_number',
        'Order ID': 'order_no',
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        'Customer Phone': 'customer_phone',
        'Second Phone Number': 'customer_secondary_phone',
        COD: 'cod',
        'Collected Cod': 'cod',
        Commission: 'rider_commission',
        Status: {
          field: 'status.name',
          callback: value => `"${value}"`,
        },
      },
      errorCount: 0,
      selectAllCheckbox: false,
      downloadReportName: 'Rider-New-Deposits',
      pageWithSelectAll: [],
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchDataForRider()
      },
    },
    deep: true,
    page() {
      this.fetchDataForRider()
    },
    perPage() {
      this.fetchDataForRider()
    },
    selectedRider: {
      async handler(val) {
        if (val === null) {
          this.clearDate('status_date')
          this.disabled = true
        }
      },
    },
  },
  mounted() {
    this.fields.push(
      {
        key: 'id',
        label: '#',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'logo_url',
        label: 'WayBill',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'customer_name',
        label: 'Customer Contact',
        sortable: true,
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'cod',
        label: `COD (${this.currency_type})`,
        sortable: true,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        key: 'collected_cod',
        label: `Collected COD (${this.currency_type})`,
        sortable: true,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        key: 'rider_commission',
        label: `Commission (${this.currency_type})`,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        key: 'status.key',
        label: 'Status',
        sortable: true,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
    )
    this.readDataforRider()
    // this.readDataforExpencesMethod()
  },
  methods: {
    async readDataforRider() {
      try {
        this.Rider = localStorage.getItem('rider_list') ? JSON.parse(localStorage.getItem('rider_list')) : (await RiderRepository.getAllRiderDropDown()).data.data
        if (!localStorage.getItem('rider_list')) localStorage.setItem('rider_list', JSON.stringify(this.Rider))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforExpencesMethod() {
      try {
        this.Expenceloading = true
        const { data } = (await FinanceRepository.getExpencesMethod()).data
        this.ExpenceOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.Expenceloading = false
    },
    async loadBills() {
      if (!this.selectedRider) {
        this.showErrorMessage('Please Select a Rider')
      } else {
        this.deselectAll()
        await this.fetchDataForRider()
      }
    },
    async fetchDataForRider() {
      this.dataLoading = true
      this.items = []
      const filterQuery = this.buildFilterQuery()
      const isChecked = this.pageWithSelectAll.includes(this.page)
      if (!isChecked) {
        this.selectAllCheckbox = false
      } else {
        this.selectAllCheckbox = true
      }
      if (this.selectedRider !== '') {
        try {
          const { data } = (await FinanceRepository.getAllRiderWaybillList(this.page, this.perPage, this.selectedRider, filterQuery))
          this.items = data.data
          this.meta = data.meta
          this.disabled = false
        } catch (e) {
          this.showErrorMessage('Sorry for the inconvenience! Please Try Again!!')
        }
      }
      this.dataLoading = false
    },
    async fetchDataForRiderNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await FinanceRepository.getAllRiderWaybillListNoPagination(this.selectedRider, filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    handleChangePage(page) {
      this.page = page
      this.fetchDataForRider()
    },
    applyFilters() {
      this.fetchDataForRider()
    },
    clearFilters() {
      this.filters = {
        status_date: {
          startDate: null,
          endDate: null,
        },
      }
      this.$nextTick(() => {
        this.fetchDataForRider()
      })
    },
    selectAll() {
      this.waybillSelected = this.items.map(n => n.waybill_number)
    },
    deselectAll() {
      this.waybillSelected = []
      this.selectAllCheckbox = false
      this.items = []
      this.meta = {}
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.waybillSelected = [...this.waybillSelected, ...this.items.map(n => n.waybill_number)]
        this.pageWithSelectAll = [...this.pageWithSelectAll, this.page]
      } else {
        this.waybillSelected = []
        this.pageWithSelectAll = []
      }
    },
    addSectionExpences() {
      const object = {
        id: ((this.expenses_section.length) + 1),
        type: '',
        amount: '',
      }
      this.expenses_section.push(object)
    },
    removeSectionExpences() {
      this.expenses_section.pop()
    },
    SubmitDeposit() {
      const depositDate = new Date().toISOString().slice(0, 10)
      const deposit = {
        rider_id: this.selectedRider,
        waybill_numbers: this.waybillSelected,
        deposit_date: depositDate,
      }
      if (this.waybillSelected.length === 0) {
        this.showErrorMessage('Please Select Waybills First')
      } else if (this.selectedRider !== this.items[0].rider.id) {
        this.showErrorMessage('Selected orders do not match the selected rider')
      } else if (this.expenses_section.length > 1) {
        // eslint-disable-next-line no-plusplus
        for (let i = 1; i <= this.expenses_section.length; i++) {
          if (this.expenses_section[i].type === '' || this.expenses_section[i].amount === '') {
            // eslint-disable-next-line no-plusplus
            this.errorCount++
          }
          break
        }
        if (this.errorCount > 0) {
          this.showErrorMessage('Please Check if data is filled')
        } else {
          deposit.expenses = this.expenses_section
          this.handleSubmit(deposit)
        }
      } else if (this.expenses_section.length === 1) {
        // eslint-disable-next-line no-plusplus
        if (this.expenses_section[0].type === '' || this.expenses_section[0].amount === '') {
          // eslint-disable-next-line no-plusplus
          this.errorCount++
        }
        if (this.errorCount > 0) {
          deposit.expenses = []
          this.handleSubmit(deposit)
        } else {
          deposit.expenses = this.expenses_section
          this.handleSubmit(deposit)
        }
      } else {
        deposit.expenses = this.expenses_section
        this.handleSubmit(deposit)
      }
    },
    async handleSubmit(deposit) {
      this.$refs.deposit_detail_modal.openModal(this.waybillSelected, this.createDeposit, deposit, 'rider')
    },
    async createDeposit(deposit) {
      const res = await FinanceRepository.createRiderFinanceDeposit(deposit)
      if (res.status === 201) {
        this.showSuccessMessage('Data Added Successfully')
        await this.$router.push('/operations/rider-finance')
      } else {
        this.showErrorMessage('Cannot Add Deposit')
      }
    },
    getCustomerFieldValue(item, fieldName) {
      if (!item) return ''
      // If order is encrypted
      if (item.is_encrypted) {
        // If user has permission to view decrypted data, show real values
        if (this.$can('show-decrypted-orders')) {
          // API returns decrypted data when user has permission, so show real value
          return item[fieldName] || ''
        }
        // User doesn't have permission - show masked
        return '******'
      }

      // Order is not encrypted - show normal data
      return item[fieldName] || ''
    },
    // Show Second number row when customer has secondary phone or when masking encrypted data
    shouldShowSecondaryPhone(item) {
      if (!item) return false
      const hasSecondaryPhone = item.customer_secondary_phone != null && item.customer_secondary_phone !== ''
      const isMaskingEncrypted = item.is_encrypted && !this.$can('show-decrypted-orders')
      return hasSecondaryPhone || isMaskingEncrypted
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
.custom-button-color-blur {
  background-color: #6da5ff !important;
  border-color: #6da5ff !important;
}
@media (max-width: 767px) {
  .table-responsive {
    position: sticky;
    top: 0;
  }
  .mobile-margin {
    margin-bottom: 20px;
    width: 100%;
  }
  .pagination-text {
    font-size: 0.75rem;
  }
}
</style>
